<template>
    <div class="loading-page">
        <div class="loading-container">
            <div class="text-center">
                <div class="loader"></div>
                <p class="loading-text">Verifica accesso in corso...</p>
                <p class="loading-subtitle">Attendere prego</p>
            </div>
        </div>
    </div>
</template>
<style scoped>
.loading-page {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #34495e 0%, #2c3e50 100%);
    position: relative;
}

.loading-page::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: inherit;
    filter: blur(10px);
    z-index: -1;
}

.loading-container {
    background: white;
    border-radius: 12px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    padding: 40px;
    max-width: 400px;
    width: 90%;
}

.loader {
    border: 6px solid #e0e0e0;
    border-top: 6px solid #007bff;
    border-radius: 50%;
    width: 60px;
    height: 60px;
    animation: spin 1.5s linear infinite;
    margin: 0 auto 20px;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

.loading-text {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin-bottom: 8px;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.loading-subtitle {
    font-size: 14px;
    color: #666;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
</style>
<script lang="ts" setup>

definePageMeta({
    auth: false,
    layout: false
})

const route = useRoute()
const companyUrl = route.params.company_url as string


console.log(`Company URL: ${companyUrl}`)


onMounted(async () => {
    try {
        await useCompanyStore().loadUser()
        console.log('User data after loadUser:', useCompanyStore().user)
        if (!useCompanyStore().user) {
            await navigateTo(`/${companyUrl}/login`)
        } else {
            await navigateTo(`/`)
        }
    } catch (error) {
        console.error('Error loading user:', error)
       await navigateTo(`/login`)

    }
})


</script>

<style scoped>
.container {
    max-width: 800px;
    margin: 0 auto;
}
</style>